import { useNavigate } from 'react-router-dom'
import { Download, Upload } from 'lucide-react'
import { Button } from '../../../../components'

interface AttendanceTabHeaderProps {
  onExport: () => void
  onImport: () => void
  isExporting?: boolean
}

export function AttendanceTabHeader({
  onExport,
  onImport,
  isExporting = false,
}: AttendanceTabHeaderProps) {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 min-w-0">
      <div className="min-w-0">
        <h1 className="text-2xl font-bold text-slate-900">Staff Attendance</h1>
        <p className="text-sm text-slate-500 mt-1">
          View and manage employee attendance records across campus faculties.
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-3 shrink-0">
        <div className="rounded-full bg-white border border-slate-200 px-3 py-2 text-xs font-semibold text-slate-700 flex items-center gap-1.5 shadow-xs">
          <span className="h-2 w-2 rounded-full bg-emerald-500 shrink-0" />
          <span>Biometric syncs automatically</span>
        </div>

        <Button
          variant="secondary"
          size="md"
          icon={<Download className="h-4 w-4" />}
          onClick={onExport}
          disabled={isExporting}
          className="bg-white hover:bg-slate-50 text-slate-700 border-slate-200 font-semibold shadow-xs"
        >
          {isExporting ? 'Exporting...' : 'Export'}
        </Button>

        <Button
          variant="secondary"
          size="md"
          icon={<Upload className="h-4 w-4" />}
          onClick={onImport}
          className="bg-white hover:bg-slate-50 text-slate-700 border-slate-200 font-semibold shadow-xs"
        >
          Import Attendance
        </Button>

        <Button
          variant="primary"
          size="md"
          onClick={() => navigate('/admin/hrms/attendance-leave/attendance/manual-attendance')}
          className="font-semibold"
        >
          Manual Attendance
        </Button>
      </div>
    </div>
  )
}
